export enum PaymentTypeEnum {
  CHECK = 'Check',
  DIRECT_DEPOSIT = 'Direct Deposit',
  CREDIT_CARD = 'Credit Card',
}

export enum InvoicePaymentTypeEnum {
  CHECK = 'Check',
  CREDIT_CARD = 'Credit Card',
  PAYROLL_WITHHELD = 'Payroll Withheld',
  ACH = 'ACH',
  GRANT = 'Grant',
  ONLINE_PAYMENT = 'Online Payment',
}

export enum InvoicePaymentStatusEnum {
  PENDING = 'Pending',
  PROCESSING = 'Processing',
  SUCCESS = 'Success',
  FAILED = 'Failed',
}
